/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemorySuggestionControllerFindAllQueryResponse, AgentMemorySuggestionControllerFindAllQueryParams, AgentMemorySuggestionControllerFindAll401, AgentMemorySuggestionControllerFindAll403 } from "../../models/agentMemorySuggestionsController/AgentMemorySuggestionControllerFindAll";

function getAgentMemorySuggestionControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/agent-memory-suggestions` as const }  
  return res
}

/**
 * @summary List pending agent memory suggestions
 * {@link /api/v1/agent-memory-suggestions}
 */
export async function agentMemorySuggestionControllerFindAll(params?: AgentMemorySuggestionControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AgentMemorySuggestionControllerFindAllQueryResponse, ResponseErrorConfig<AgentMemorySuggestionControllerFindAll401 | AgentMemorySuggestionControllerFindAll403>, unknown>({ method : "GET", url : getAgentMemorySuggestionControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}